import { Route, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import LoadingGlobal from '../components/LoadingGlobal/LoadingGlobal';
import SelecionarPerfil from '../features/Perfil/components/SelecionarPerfil/SelecionarPerfil';
import { getPerfis, getSituacaoCadastroFamilia, limparPerfil, selectPerfilCompleto, selectPerfis, selectSituacaoCadastroFamilia } from '../features/Perfil/perfilSlice';
import TermoDeUso from '../features/TermoDeUso/TermoDeUso';
import { selectTemTermoAssinado } from '../features/TermoDeUso/termoDeUsoSlice';
import {limparAuth, loginGateway, selectGateway, setGovBrLogado } from './authSlice';
import { useEffect, useState } from 'react';
import { limparDadosFamilia } from '../features/ConsultaSimples/consultaSimplesSlice';
import { setLoggingIn } from '../globalSlice';
import auth from './Auth';


const ProtectedRoute = ({ component: Component, ...restOfProps }) => {

  const dispatch = useAppDispatch();

  const isAuthenticatedGateway = useAppSelector(selectGateway).logado;
  const temTermoDeUsoAssinado = useAppSelector(selectTemTermoAssinado);
  const perfil = useAppSelector(selectPerfilCompleto);

  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const history = useHistory();

  const [ popupIntervalId, setPopupIntervalId ] = useState(undefined as any);

  const perfis = useAppSelector(selectPerfis);

  useEffect(() => {
    const cpfUser = auth.getUser();
    if (cpfUser && auth.isAuthenticated() && !perfis) {
      dispatch(getPerfis(cpfUser));
    }
  }, [dispatch,perfis]);

  useEffect(() => {
    const cpfUser = auth.getUser();
    if (cpfUser && !situacaoCadastroFamilia) {
      dispatch(getSituacaoCadastroFamilia({ cpf: cpfUser, history }));
    }
}, [dispatch, situacaoCadastroFamilia]);


 /* useEffect(() => {
    if (auth.isAuthenticated()) {
      dispatch(getPerfis(auth.getUser()));
    }
  }, [dispatch, auth.getUser()]);
*/
  useEffect(() => {
    // Caso ele feche o aplicativo durante o login
    if (!auth.getUser()) {
      dispatch(limparAuth());
    }
    localStorage.removeItem('autenticando');
  }, []);

  useEffect(() => {
    if (!isAuthenticatedGateway && restOfProps.govBrOnly) {
      dispatch(limparPerfil());
      dispatch(limparDadosFamilia());
      dispatch(loginGateway(restOfProps.path));
      dispatch(setLoggingIn(true));

      if (!popupIntervalId) {
        setPopupIntervalId(setInterval(() => {
          if (auth.isAuthenticated()) {
            clearInterval(popupIntervalId);
            setPopupIntervalId(undefined);
            dispatch(setLoggingIn(false));
            dispatch(setGovBrLogado(true));
          } else if (auth.isAuthenticatedClose()) {
            clearInterval(popupIntervalId);
            setPopupIntervalId(undefined);
            dispatch(setLoggingIn(false));
            dispatch(limparAuth());
            auth.limparStorage();
            history.replace("/");
          }
        }, 5000));
      }
    }
  }, [isAuthenticatedGateway, dispatch, history, popupIntervalId, restOfProps.govBrOnly, restOfProps.path]);


  const render = (props: any) => {

    const allSelectorsLoaded =
    perfil !== undefined &&
    situacaoCadastroFamilia !== undefined;

    if (!allSelectorsLoaded || (!isAuthenticatedGateway && restOfProps.govBrOnly)) {
      return <LoadingGlobal />;
    }

    if (restOfProps.isHome) {
      /**
       * Nas situações em que o usuário estiver na tela inicial e:
       *
       * 1. Não estiver logado de nenhuma maneira (gov.br ou id. positiva)
       * 2. Já logou pelo gov.br, porém ainda não buscou por dados de situação do cadastro da família
       *
       * Renderizamos o componente da tela inicial sem passar pelo restante do fluxo do
       * ProtectedRoute.tsx
       */
      if (
        (!isAuthenticatedGateway) || (isAuthenticatedGateway && !situacaoCadastroFamilia)
      ) {
        return <Component {...props} />;
      }
    }

    if (!temTermoDeUsoAssinado) {
      return <TermoDeUso comeFromProtectedRoute={true} />;
    }

   if(perfis && perfis.length > 1 && !perfil){
    return <SelecionarPerfil />;
   }


    return <Component {...props} />;
  };
  return <Route {...restOfProps} render={render} />;
};

export default ProtectedRoute;
